import React, { useState, useEffect } from 'react'
import { connect } from "react-redux"
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import DataTable from 'react-data-table-component'
import Divider from "@material-ui/core/Divider"
import Button from "@material-ui/core/Button"
import Box from "@material-ui/core/Box"
import { CollateralStyles } from '../../CollateralStyles'
import { useTranslation } from 'react-i18next'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Modal from 'antd/es/modal';
import TextField from '@material-ui/core/TextField'
import { Container } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import { customStyleSecondary } from '../../../common/CommonStyles'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import { Backdrop, CircularProgress } from '@material-ui/core'

const Subphases = ({ classes, ...props }) => {
    const [subStageType, setSubStageType] = useState([]);
    const [subStageDesc, setSubStageDesc] = useState([])
    const { t } = useTranslation()
    const [openBackdrop, setOpenBackdrop] = useState(false);

    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const saveSubStageBody = {
        "OrderNumber": props.workDetail[0].woid,
        "SubStageId": subStageDesc.subStageID,
        "branchOfficeID": parseInt(props.match.params.branchOfficeId)
    }

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_Substage_Per_Order(props.userLanguage, props.userToken, props.workDetail[0].woid, props.match.params.branchOfficeId, onError, onSuccess)
        props.actions.fetch_Substage(props.userLanguage, props.userToken, 3, onError, onSuccess)
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const handleOnClick = () => {
        props.actions.save_SubStage(props.userLanguage, props.userToken, saveSubStageBody, onError, onSuccessSave)
    }

    const handleDelete = (subStageId) => {
        handleOpenBackdrop()
        props.actions.delete_SubStage(props.userLanguage, props.userToken, subStageId, props.match.params.branchOfficeId, props.workDetail[0].woid, onError, onSuccessDelete)
    }

    const onSuccessDelete = (response) => {
        handleCloseBackdrop()
        if (response.success) {
            Modal.success({
                title: t('commonMessages.deletedSucc')
            })
        } else {
            Modal.error({
                title: 'Error',
                content: t('collateralDetails.errorSubstages')
            })
        }
        props.actions.fetch_Substage_Per_Order(props.userLanguage, props.userToken, props.workDetail[0].woid, props.match.params.branchOfficeId, onError, onSuccess)
    }

    const onSuccessSave = () => {
        Modal.success({
            title: <Typography variant="body1" style={{ fontWeight: 600 }}>{t('commonMessages.savedSucc')}</Typography>
        })
        props.actions.fetch_Substage_Per_Order(props.userLanguage, props.userToken, props.workDetail[0].woid, props.match.params.branchOfficeId, onError, onSuccess)
        setSubStageDesc([])
        setSubStageType([])
    }
    //*First Render Functions
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('collateralDetails.errorSubstages')
                    })
                    break
                default:
                    break
            }
        }
    }

    const columns = [
        {
            name: t('collateralDetails.subphase'),
            selector: 'subStageDescription',
            sortable: true,
            width: '800px',
            cell: row => row.subStageDescription
        },
        {
            name: t('collateralDetails.registerDate'),
            selector: 'subStageDate',
            sortable: true,
            width:'150',
            cell: row => row.subStageDate
        },
        {
            name: "",
            center: true,
            width: '150px',
            cell: row => (buttonForColumns(row))
        }
    ]

    const buttonForColumns = (row) => {
        return (
            <div>
                <Tooltip title={t('common.delete')}>
                    <IconButton style={{ color: '#BF2E2E' }} onClick={() => handleDelete(row.id)}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    return (
        <div>
            {props.subStagePerOrder
                ?
                <Container className={classes.generalBorder}>
                    <Backdrop className={classes.backdrop} open={openBackdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <br />
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={5}
                    >
                        <br />
                        <br />
                        <Grid item xs>
                            <FormControl>
                                <Autocomplete
                                    disableClearable={true}
                                    onChange={(event, newValue) => {
                                        setSubStageType(newValue);
                                    }}
                                    size="small"
                                    value={subStageType}
                                    style={{ width: 500 }}
                                    options={props.subStage}
                                    getOptionLabel={(option) => option.subStageType}
                                    getOptionSelected={(option, value) => option.subStageType === value.subStageType}
                                    renderInput={(params) => <TextField {...params} label={t('collateralDetails.selectSubstage')} variant="outlined" />}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs>
                            {
                                subStageType.collateralSubStagesList !== undefined
                                    ?
                                    <div>
                                        <FormControl>
                                            <Autocomplete
                                                disableClearable={true}
                                                onChange={(event, newValue) => {
                                                    setSubStageDesc(newValue);
                                                }}
                                                size="small"
                                                value={subStageDesc}
                                                style={{ width: 500 }}
                                                options={subStageType.collateralSubStagesList}
                                                getOptionLabel={(option) => option.statusDescription}
                                                getOptionSelected={(option, value) => option.statusDescription === value.statusDescription}
                                                renderInput={(params) => <TextField {...params} label={t('commonMessages.descriptionSelect')} variant="outlined" />}
                                            />
                                        </FormControl>
                                    </div>
                                    : <br />
                            }
                        </Grid>
                    </Grid>
                    <br />
                    <br />
                    <Divider />
                    <br />
                    <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="flex-end"
                        spacing={1}
                    >   <Grid item xs={9}><br /></Grid>
                        {
                            subStageType.collateralSubStagesList !== undefined
                                ?
                                <Grid item xs>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        onClick={handleOnClick}
                                    >
                                        {t('common.save')}
                                    </Button>
                                </Grid>
                                : <br />}
                    </Grid>

                    <Box width="100%">
                        <br />
                        <DataTable
                            columns={columns}
                            customStyles={customStyleSecondary}
                            data={props.subStagePerOrder}
                            highlightOnHover
                            defaultSortField="subStageDate"
                            dense
                            noHeader
                            pointerOnHover
                            pagination
                            paginationComponentOptions={paginationOptions}
                        />
                        {
                            props.subStagePerOrder && props.subStagePerOrder.length < 1 && (
                                <Grid container item xs={12}><br /></Grid>
                            )
                        }
                    </Box>
                </Container>
                :
                <CircularProgress color="inherit" />}
        </div>
    )
}

const mapStateToProps = state => ({
    subStagePerOrder: state.CollateralReducer.subStagePerOrder,
    subStage: state.CollateralReducer.subStage,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

export default connect(mapStateToProps)(withStyles(CollateralStyles)(Subphases))